import { DatePipe } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { FormSessionCanDeactivate, PatientService, UserService } from '../../shared';
import { User } from '../../shared/models';

@Component({
  selector: 'app-addnewpatient',
  templateUrl: './addnewpatient.component.html',
  styleUrls: ['./addnewpatient.component.css']
})
export class AddnewpatientComponent extends FormSessionCanDeactivate {

  modalRef: BsModalRef;
  //define a new patient variable
  public newPatient: any = {
    fName: '',
    lName: '',
    gender: '',
    dob: '',
    email: '',
    phone: '',
    mrn: '',
    ssn: '',
    height: '',
    weight: '',
    inch: '',
    bmi: '',
    regularSmoker: '',
    diabetic: '',
    bloodPressure: '',
    uploadimage: [],
    AddBodyPart: []
  };
  public temPatien: any = {};
  //default common bodyDetails used push eveerytime when add a bodypart
  public bodyPartDetails: any = {
    dosStatus: 'notSelected',
    bodyLocation: '',
    bodyPart: '',
    surgeonId: '',
    payorType: '',
    mako: '',
    hospitalId: '',
    dischargeWith: '',
    dischargeLoc: '',
    dischargeTo: '',
    cjr: ''
  };
  public userRole: User;
  //body parts array
  public listOfParts = [];
  public bodyParts = [];
  public surgeonList = [];
  public snfList = [];
  public hospitalList = [];
  public temArray = [];
  public surgeonUserNames = [];
  public patientUrl = './assets/img/users/Default_carepartner_female.svg'
  public defaultUl = './assets/img/users/Default_carepartner_female.svg'
  public modelMsg = "";
  public dosStatus = 'notSelected';
  public bobMaxDate = new Date();
  public imgMaxSize = environment.imagefileSize;
  public defaultBodyPart = {
    carePath: '',
    bodyPartStatus: 'False',
    laterality: '',
    hospitalId: '',
    surgeonId: '',
    dos: '',
    mako: '',
    cjr: '',
    payorType: '',
    hic: '',
    dischargeDate: '',
    dischargeLoc: '',
    facilityPhone: '',
    facilityContact: '',
    dischargeWith: '',
    dischargeId: '',
    dischargeHospitalMasterId: '',
    dischargeTo: '',
    bpci: ''
  }
  public imagearr = [];
  @ViewChild('myInput')
  myInputVariable: any;
  //upper body options array
  public upperBodypartOption = [{
    'value': "Neck-Neck",
    'name': 'Neck'
  }, {
    'value': "Back-Back",
    'name': 'Back'
  }, {
    'value': 'Neck-Back',
    'name': 'Neck & Back'
  }, {
    'value': 'Shoulder-Left',
    'name': 'Shoulder - Left'
  }, {
    'value': 'Shoulder-Right',
    'name': 'Shoulder - Right'
  }, {
    'value': 'Elbow-Left',
    'name': 'Elbow - Left'
  }, {
    'value': 'Elbow-Right',
    'name': 'Elbow - Right'
  }, {
    'value': 'Hand-Left',
    'name': 'Hand - Left'
  }, {
    'value': 'Hand-Right',
    'name': 'Hand - Right'
  },
  {
    'value': 'Wrist-Left',
    'name': 'Wrist - Left'
  }, {
    'value': 'Wrist-Right',
    'name': 'Wrist - Right'
  }, {
    'value': 'Arm-Left',
    'name': 'Arm - Left'
  }, {
    'value': 'Arm-Right',
    'name': 'Arm - Right'
  }, {
    'value': 'Fore Arm-Left',
    'name': 'Fore Arm - Left'
  }, {
    'value': 'Fore Arm-Right',
    'name': 'Fore Arm - Right'
  }
  ]
  //lower body Option Array 
  public lowerBodypartOption = [{
    'value': "Total Hip Replacement-Left",
    'name': 'Total Hip - Left'
  }, {
    'value': "Total Hip Replacement-Right",
    'name': 'Total Hip - Right'
  }, {
    'value': 'Total Hip Replacement-Bilateral',
    'name': 'Total Hip - Bilateral'
  }, {
    'value': 'Total Knee Replacement-Left',
    'name': 'Total Knee - Left'
  }, {
    'value': 'Total Knee Replacement-Right',
    'name': 'Total Knee - Right'
  }, {
    'value': 'Total Knee Replacement-Bilateral',
    'name': 'Total Knee - Bilateral'
  }, {
    'value': 'Partial Knee Replacement-Left',
    'name': 'Partial Knee - Left'
  }, {
    'value': 'Partial Knee Replacement-Right',
    'name': 'Partial Knee - Right'
  }, {
    'value': 'Partial Knee Replacement-Bilateral',
    'name': 'Partial Knee - Bilateral'
  },
  {
    'value': 'Sports Knee-Left',
    'name': 'Knee Sports - Left'
  }, {
    'value': 'Sports Knee-Right',
    'name': 'Knee Sports - Right'
  }, {
    'value': 'Sports Hip-Left',
    'name': 'Hip Sports - Left'
  }, {
    'value': 'Sports Hip-Right',
    'name': 'Hip Sports - Right'
  }, {
    'value': 'Foot-Left',
    'name': 'Foot - Left'
  }, {
    'value': 'Foot-Right',
    'name': 'Foot - Right'
  }, {
    'value': 'Ankle-Left',
    'name': 'Ankle - Left'
  }, {
    'value': 'Ankle-Right',
    'name': 'Ankle - Right'
  }
  ]
  public stageArray: any = [];
  public showTable = false;
  public materialsArray: any = [];
  constructor(private userService: UserService,
    private patientService: PatientService,
    private datepipe: DatePipe, private toast: ToastrService,
    private router: Router, private modalService: BsModalService) {
    super();
  }


  ngOnInit() {
    let self = this;
    let pusdata = Object.assign({}, self.bodyPartDetails)
    self.listOfParts.push(pusdata)
    // self.getLoggedUserDetails();
    self.getSurgeonNames();
    self.getHospitalLsit();
    self.getSnfNames();
  }
  //get Loogged user Deatils
  getLoggedUserDetails() {
    let self = this;
    self.userService.currentUser
      .subscribe(
        data => {
          self.userRole = data
        }
      )

  }


  //get surgeon names for the drop down surgeon
  getSurgeonNames() {
    let self = this;
    self.patientService.getSurgeonlist(self.hospitalList)
      .subscribe(data => {
        self.surgeonList = data
      })
  }
  //get options for snf names
  getSnfNames() {
    let self = this;
    self.patientService.getSnfList()
      .subscribe(data => {
        self.snfList = data.aaData[0].dischargehospitalList
      })
  }

  //check the dos and changes it's status
  onDateValueChange(event, form) {
    let self = this;
    let date = this.datepipe.transform(event, 'yyyy-MM-dd');
    if (date) {
      if (!self.newPatient.dob) {
        self.toast.error('Please select DOB')
        return;
      }
      let toDate = new Date();
      toDate.setDate(toDate.getDate() - 1);
      let Dos = new Date(date);
      if (toDate.getTime() <= Dos.getTime()) {
        if (form == 'main') {
          self.dosStatus = "future"
        }
        if (form != 'main') {
          self.listOfParts[form]['dosStatus'] = "future"
        }
      }

      if (toDate.getTime() > Dos.getTime()) {
        if (form == 'main') {
          self.dosStatus = "past"
        }
        if (form != 'main') {
          self.listOfParts[form]['dosStatus'] = "past"
        }
      }
    } else {
      if (form != 'main') {
        self.listOfParts[form]['dosStatus'] = "notSelected"
      }
    }
  }
  //calculate the bmi 
  calculateBmi() {
    let self = this;
    if (self.newPatient.weight && self.newPatient.height && self.newPatient.inch) {
      self.calculateBMI(self.newPatient.weight, self.newPatient.height, self.newPatient.inch)
    } else {
      self.newPatient.bmi = null;
    }
  }
  //calculate bmi
  calculateBMI(weight, height, inch) {
    let self = this;
    weight = parseFloat(weight);
    height = parseInt(height);
    inch = parseInt(inch);

    weight = weight * 0.453592;
    height = (((height * 12) + inch) * .0254);
    let bmi = weight / Math.pow(height, 2.0);
    self.newPatient.bmi = bmi.toFixed(2)
  }

  //add a new  body part 
  addBodyPart(data) {

    let self = this;
    //let index = self.listOfParts.length;
    if (self.listOfParts.length < 3) {
      let pushdata = Object.assign({}, self.bodyPartDetails)
      self.listOfParts.push(pushdata)
      //  if(!self.listOfParts.length){
      //   data.dosStatus =self.dosStatus;
      //   data.bodyParts = self.bodyParts;
      //   data.surgeonUserNames = self.surgeonUserNames;
      //   let pushData1 = Object.assign({},data)
      //   let pushData2 = Object.assign({},data)
      //   self.listOfParts.push(pushData1)
      //    self.listOfParts.push(pushData2)
      //  }else{
      //   let pushData = Object.assign({},data)
      //   self.listOfParts.push(pushData)
      //  }
    } else {
      //  self.toast.error(`Can't add more than three body part`);
    }

    //  self.listOfParts[index]=pushData;
  }

  //remove the body part form the list 
  /**
   * 
   * @param data form
   * @param index index of array
   */
  removeBodyPart(data: NgForm, index) {
    let self = this;
    let length = self.listOfParts.length;
    for (let i = index; i < length - 1; i++) {
      self.listOfParts[i] = self.listOfParts[i + 1];
    }
    self.listOfParts.splice(length - 1, 1)
    let l2 = self.listOfParts.length
    self.getBodyParts(self.listOfParts[l2 - 1].bodyLocation, l2 - 1);
  }

  changeBodyLocation() {

  }


  //get hispital list for drop down
  getHospitalLsit() {
    let self = this;
    self.patientService.getHospitalList(self.hospitalList)
      .subscribe(data => {
        self.hospitalList = _.filter(data.aaData, (o) => {
          return o.hospitalId != 10001
        })
      })
  }
  //clear the mrn number by click
  /**
   * 
   * @param event check box event
   */
  setMRNnull(event) {
    let self = this;
    if (self.newPatient.mrn) {
      self.newPatient.mrn = '';
    }
  }
  //clear the ssn number in click
  /**
   * 
   * @param event check box event
   */
  setssnnull(event) {
    let self = this;
    if (self.newPatient.ssn) {
      self.newPatient.ssn = ''
    }
  }
  //get body part option based on the body location
  /**
   * 
   * @param event body location value
   * @param form index of array
   */
  getBodyParts(event, form) {
    let self = this;
    //////console.log(self.upperBodypartOption)

    self.bodyParts = [];
    if (event == 'upper') {
      if (form == 'main') {
        self.bodyParts = self.upperBodypartOption;
      }
      if (form != 'main') {
        if (self.listOfParts.length == 1) {
          self.listOfParts[0].upperbodyParts = self.upperBodypartOption;
          return;
        }
        if (self.listOfParts.length == 2) {
          if (self.listOfParts[1].bodyPart == 'Neck-Back') {
            self.listOfParts[0].upperbodyParts = self.filterNeckAndBack(self.upperBodypartOption, 'Neck-Neck', 'Back-Back', self.listOfParts[1].bodyPart)
          } else if (self.listOfParts[1].bodyPart == 'Neck-Neck' || self.listOfParts[1].bodyPart == 'Back-Back') {
            self.listOfParts[0].upperbodyParts = self.filterNeckAndBack(self.upperBodypartOption, 'Neck-Back', self.listOfParts[1].bodyPart)
          } else {
            self.listOfParts[0].upperbodyParts = _.reject(self.upperBodypartOption, ['value', self.listOfParts[1].bodyPart]);
          }
          if (self.listOfParts[0].bodyPart == 'Neck-Back') {
            self.listOfParts[1].upperbodyParts = self.filterNeckAndBack(self.upperBodypartOption, 'Neck-Neck', 'Back-Back', self.listOfParts[1].bodyPart)
          } else if (self.listOfParts[0].bodyPart == 'Neck-Neck' || self.listOfParts[0].bodyPart == 'Back-Back') {
            self.listOfParts[1].upperbodyParts = self.filterNeckAndBack(self.upperBodypartOption, 'Neck-Back', self.listOfParts[1].bodyPart)
          } else {
            self.listOfParts[1].upperbodyParts = _.reject(self.upperBodypartOption, ['value', self.listOfParts[0].bodyPart]);
          }
          return;
        }
        if (self.listOfParts.length == 3) {
          let lsit0 = [];
          let lsit1 = []
          let lsit2 = [];
          if (self.listOfParts[1].bodyPart == 'Neck-Back') {
            lsit0 = self.filterNeckAndBack(self.upperBodypartOption, 'Neck-Neck', 'Back-Back', self.listOfParts[1].bodyPart);
          } else if (self.listOfParts[1].bodyPart == 'Neck-Neck' || self.listOfParts[1].bodyPart == 'Back-Back') {
            lsit0 = self.filterNeckAndBack(self.upperBodypartOption, 'Neck-Back', self.listOfParts[1].bodyPart);
          } else {
            lsit0 = _.reject(self.upperBodypartOption, ['value', self.listOfParts[1].bodyPart])
          }
          if (self.listOfParts[0].bodyPart == 'Neck-Back') {
            lsit1 = self.filterNeckAndBack(self.upperBodypartOption, 'Neck-Neck', 'Back-Back', self.listOfParts[0].bodyPart);
            lsit2 = self.filterNeckAndBack(self.upperBodypartOption, 'Neck-Neck', 'Back-Back', self.listOfParts[0].bodyPart);
          } else if (self.listOfParts[0].bodyPart == 'Neck-Neck' || self.listOfParts[0].bodyPart == 'Back-Back') {
            lsit1 = self.filterNeckAndBack(self.upperBodypartOption, 'Neck-Back', self.listOfParts[0].bodyPart);
            lsit2 = self.filterNeckAndBack(self.upperBodypartOption, 'Neck-Back', self.listOfParts[0].bodyPart);
          } else {
            lsit1 = _.reject(self.upperBodypartOption, ['value', self.listOfParts[0].bodyPart])
            lsit2 = _.reject(self.upperBodypartOption, ['value', self.listOfParts[0].bodyPart])
          }

          if (self.listOfParts[2].bodyPart == 'Neck-Back') {
            self.listOfParts[0].upperbodyParts = self.filterNeckAndBack(lsit0, 'Neck-Neck', 'Back-Back', self.listOfParts[2].bodyPart);
            self.listOfParts[1].upperbodyParts = self.filterNeckAndBack(lsit1, 'Neck-Neck', 'Back-Back', self.listOfParts[2].bodyPart);
          } else if (self.listOfParts[2].bodyPart == 'Neck-Neck' || self.listOfParts[2].bodyPart == 'Back-Back') {
            self.listOfParts[0].upperbodyParts = self.filterNeckAndBack(lsit0, 'Neck-Back', self.listOfParts[2].bodyPart);
            self.listOfParts[1].upperbodyParts = self.filterNeckAndBack(lsit1, 'Neck-Back', self.listOfParts[2].bodyPart);
          } else {
            self.listOfParts[0].upperbodyParts = _.reject(lsit0, ['value', self.listOfParts[2].bodyPart]);
            self.listOfParts[1].upperbodyParts = _.reject(lsit1, ['value', self.listOfParts[2].bodyPart]);
          }
          if (self.listOfParts[1].bodyPart == 'Neck-Back') {
            self.listOfParts[2].upperbodyParts = self.filterNeckAndBack(lsit2, 'Neck-Neck', 'Back-Back', self.listOfParts[1].bodyPart);
          } else if (self.listOfParts[1].bodyPart == 'Neck-Neck' || self.listOfParts[1].bodyPart == 'Back-Back') {
            self.listOfParts[2].upperbodyParts = self.filterNeckAndBack(lsit2, 'Neck-Back', self.listOfParts[1].bodyPart);
          } else {
            self.listOfParts[2].upperbodyParts = _.reject(lsit2, ['value', self.listOfParts[1].bodyPart]);
          }
        }
      }
    }

    if (event == 'lower') {
      if (form == 'main') {
        self.bodyParts = self.lowerBodypartOption;
      }
      if (form != 'main') {
        if (self.listOfParts.length == 1) {
          self.listOfParts[form].lowerbodyParts = self.lowerBodypartOption;
          return;
        }
        if (self.listOfParts.length == 2) {
          if (self.listOfParts[1].bodyPart.includes('Knee') || self.listOfParts[1].bodyPart.includes('Hip')) {
            self.listOfParts[0].lowerbodyParts = self.filterBilater(self.lowerBodypartOption, self.listOfParts[1].bodyPart)
          } else {
            self.listOfParts[0].lowerbodyParts = _.reject(self.lowerBodypartOption, ['value', self.listOfParts[1].bodyPart]);
          }
          if (self.listOfParts[0].bodyPart.includes('Knee') || self.listOfParts[0].bodyPart.includes('Hip')) {
            self.listOfParts[1].lowerbodyParts = self.filterBilater(self.lowerBodypartOption, self.listOfParts[0].bodyPart);
          } else {
            self.listOfParts[1].lowerbodyParts = _.reject(self.lowerBodypartOption, ['value', self.listOfParts[0].bodyPart]);
          }
          return
        }
        if (self.listOfParts.length == 3) {
          let lsit0 = [];
          let lsit1 = []
          let lsit2 = [];
          if (self.listOfParts[1].bodyPart.includes('Knee') || self.listOfParts[1].bodyPart.includes('Hip')) {
            lsit0 = self.filterBilater(self.lowerBodypartOption, self.listOfParts[1].bodyPart)
          } else {
            lsit0 = _.reject(self.lowerBodypartOption, ['value', self.listOfParts[1].bodyPart]);
          }
          if (self.listOfParts[0].bodyPart.includes('Knee') || self.listOfParts[0].bodyPart.includes('Hip')) {
            lsit1 = self.filterBilater(self.lowerBodypartOption, self.listOfParts[0].bodyPart)
            lsit2 = self.filterBilater(self.lowerBodypartOption, self.listOfParts[0].bodyPart)
          } else {
            lsit1 = _.reject(self.lowerBodypartOption, ['value', self.listOfParts[0].bodyPart])
            lsit2 = _.reject(self.lowerBodypartOption, ['value', self.listOfParts[0].bodyPart])
          }
          if (self.listOfParts[2].bodyPart.includes('Knee') || self.listOfParts[2].bodyPart.includes('Hip')) {
            self.listOfParts[0].lowerbodyParts = self.filterBilater(lsit0, self.listOfParts[2].bodyPart)
            self.listOfParts[1].lowerbodyParts = self.filterBilater(lsit1, self.listOfParts[2].bodyPart)
          } else {
            self.listOfParts[0].lowerbodyParts = _.reject(lsit0, ['value', self.listOfParts[2].bodyPart]);
            self.listOfParts[1].lowerbodyParts = _.reject(lsit1, ['value', self.listOfParts[2].bodyPart]);
          }
          if (self.listOfParts[1].bodyPart.includes('Knee') || self.listOfParts[1].bodyPart.includes('Hip')) {
            self.listOfParts[2].lowerbodyParts = self.filterBilater(lsit2, self.listOfParts[1].bodyPart)
          } else {
            self.listOfParts[2].lowerbodyParts = _.reject(lsit2, ['value', self.listOfParts[1].bodyPart]);
          }



          //  self.listOfParts[0].bodyParts = _.reject(_.reject(self.lowerBodypartOption,['value',self.listOfParts[1].bodyPart]),self.listOfParts[2].bodyPart);
          //  self.listOfParts[1].bodyParts = _.reject(_.reject(self.lowerBodypartOption,['value',self.listOfParts[0].bodyPart]),self.listOfParts[2].bodyPart);
          //  self.listOfParts[2].bodyParts = _.reject(_.reject(self.lowerBodypartOption,['value',self.listOfParts[0].bodyPart]),self.listOfParts[1].bodyPart);
        }
      }
    }
  }
  //filter bodyparts option array
  /**
   * 
   * @param dataArray bodyPart option array
   * @param value filter value
   */
  filterBilater(dataArray, value) {
    if (value.includes('Bilateral')) {
      let array = value.split('-')
      return _.reject(dataArray, function (o) {
        return o.value.includes(array[0])
      })
    } else {
      let temArray = [];
      temArray.push(value);
      let sarray = value.split('-');
      sarray[1] = 'Bilateral';
      temArray.push(sarray.join('-'))
      return _.reject(dataArray, function (o) {
        return temArray.includes(o.value)
      })
    }
  }
  //filter the upper body option neck and back
  /**
   * 
   * @param dataArray upper body option array
   * @param arg filter value user spred operator to get array
   */
  filterNeckAndBack(dataArray, ...arg) {
    return _.reject(dataArray, o => {
      return arg.includes(o.value)
    })
  }
  //filter option for drop down discharge event
  /**
   * 
   * @param event select surgeon id
   * @param form index
   */
  formSurgeonIdChange(event, form) {
    let self = this;
    let temArray = []
    temArray = _.filter(self.surgeonList, (n) => {
      return n.surgeonId == event
    })
    if (form == 'main') {
      self.surgeonUserNames = temArray
    }
    if (form != 'main') {
      self.listOfParts[form].surgeonUserNames = temArray
    }

  }




  //validate the email address using regex pattern
  /**
   * 
   * @param email patient email
   * 
   */
  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  //check email is already taken 
  checkEmail() {
    let self = this;
    if (!self.newPatient.email) {
      return;
    }
    let checkEmail = self.validateEmail(self.newPatient.email)
    if (checkEmail) {
      self.patientService.getPatientEmailExist(self.newPatient.email, self.userRole.item.userAccountKey)
        .subscribe(data => {
          if (data) {
            self.newPatient.email = ""
            self.toast.error("This email has already been registered")
          }
        })
    } else {
      self.newPatient.email = ""
      self.toast.error('Enter a valid email id for patient')

    }
  }
  //check phone number is already exists
  checkPhone() {
    let self = this;
    if (self.newPatient.phone) {
      self.patientService.chenckPatientPhoneExists(self.newPatient.phone, '')
        .subscribe(data => {
          if (data) {
            self.toast.error(" Phone number is already Exists")
          } else {
            self.newPatient.phone = ""
          }
        })
    }
  }
  //check mrn number is already exists
  checkMrn() {
    let self = this;
    if (self.newPatient.mrn) {
      self.patientService.checkPatientMrnExist(self.newPatient.mrn, self.userRole.item.userAccountKey)
        .subscribe(data => {
          if (data) {
            self.toast.error(this.userService.translateText('hospital_portal.disp_messages.mrn_already_registered.error'))
            self.newPatient.mrn = ""
          }
        })
    }

  }
  //check ssn already exists
  checkSsn() {
    let self = this;
    if (self.newPatient.ssn) {
      self.patientService.checkPatientSsnExists(self.newPatient.ssn)
        .subscribe(data => {
          if (data) {
            self.newPatient.ssn = ''
            self.toast.error(this.userService.translateText('hospital_portal.disp_messages.ssn_already_registered.error'))
          }
        })
    }
  }
  //check service is available with logged cc
  /**
   * 
   * @param event service line value
   * @param index index
   */

  //upload patient image
  /**
   * 
   * @param event file upload event
   */
  fileUpload(event) {
    let acceptFormat = ['image/png', 'image/x-png', 'image/jpeg', 'image/jpg']
    let reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (events: any) => {
      if (!acceptFormat.includes(event.target.files[0].type)) {
        this.toast.error(this.userService.translateText('patient_portal.validations.file_not_allowed.error_label'))
        this.myInputVariable.nativeElement.value = "";
        this.patientUrl = this.defaultUl;
        return;
      }
      if (event.target.files[0].size > this.imgMaxSize) {
        this.toast.error(this.userService.translateText('patient_portal.validations.maximum_size_exceed.error_label'))
        this.myInputVariable.nativeElement.value = "";
        this.patientUrl = this.defaultUl;
        return;
      } else {
        this.patientUrl = events.currentTarget.result;
        this.imagearr = [{
          filename: event.target.files[0].name,
          filetype: event.target.files[0].type,
          value: events.currentTarget.result.split(',')[1]
        }];
      }

    }
  }
  //save patient details
  /**
   * 
   * @param f formobject
   * @param redirect option to redirect home or not
   */
  savePatient(f: NgForm, redirect) {
    // ////console.log()
    let self = this;
    if (self.listOfParts.length == 0) {
      self.toast.error('Add atleast one body part');
      return;
    }
    let telecode = self.newPatient.code.split(',')

    const patientExist = {
      "email": self.newPatient.email,
      "hospitalId": "this.currentUser.item.userAccountKey",
      "phone": self.newPatient.phone,
      "teleCode": telecode[0]
    }
    self.patientService.checkPatienExists(patientExist)
      .subscribe(data => {
        if (data) {
          self.toast.error('Patient already exists')
        } else {
          self.arrangreData().then(
            data => {
              self.patientService.addNewPatient(data, self.userRole.item.userAccountId, '', '')
                .subscribe(data => {
                  if (data) {
                    self.toast.success(this.userService.translateText('hospital_portal.add_patient.patient_saved.success'));
                    if (redirect) {
                      self.router.navigate(['/care/mytodo'],)
                    }
                    if (!redirect) {
                      self.router.navigate(['/care/addnewpatient'])
                    }
                  }
                  if (!data) {
                    self.toast.error(this.userService.translateText('hospital_portal.disp_messages.patient_not_saved.error'));
                    this.ngOnInit();
                  }
                })
            }
          )
        }
      })

  }
  //before save the patient details rearrange the data in meaning full json
  arrangreData() {
    let self = this;
    self.temPatien = Object.assign({}, self.newPatient)
    if (self.newPatient.dob) {
      self.temPatien.dob = self.datepipe.transform(self.temPatien.dob, 'yyyy-MM-dd');
    }
    if (self.imagearr.length) {
      self.temPatien.uploadimage = self.imagearr;
    }
    let promise = new Promise((resolve, reject) => {
      for (let i = 0; i < 3; i++) {
        if (self.listOfParts[i]) {
          let bodyPart = {
            carePath: '',
            bodyPartStatus: 'False',
            laterality: '',
            hospitalId: '',
            surgeonId: '',
            dos: '',
            mako: '',
            cjr: '',
            payorType: '',
            hic: '',
            dischargeDate: '',
            dischargeLoc: '',
            facilityPhone: '',
            facilityContact: '',
            dischargeWith: '',
            dischargeId: '',
            dischargeHospitalMasterId: '',
            dischargeTo: '',
            bpci: ''
          }
          if (self.listOfParts[i]) {
            bodyPart.bodyPartStatus = "True";
            if (self.listOfParts[i].hasOwnProperty('bodyPart')) {
              let data = self.listOfParts[i]['bodyPart'].split('-');
              bodyPart.carePath = `'${data[0]}'`;
              bodyPart.laterality = `'${data[1]}'`;
            }
            if (self.listOfParts[i].hasOwnProperty('hospitalId')) {
              bodyPart.hospitalId = self.listOfParts[i].hospitalId;
            }
            if (!bodyPart.hospitalId) {
              bodyPart.hospitalId = '10001';
            }
            if (self.listOfParts[i].hasOwnProperty('surgeonId')) {
              bodyPart.surgeonId = self.listOfParts[i].surgeonId;
            }
            if (self.listOfParts[i].hasOwnProperty('dos')) {
              bodyPart.dos = self.datepipe.transform(self.listOfParts[i].dos, 'yyyy-MM-dd')
            }
            if (self.listOfParts[i].hasOwnProperty('mako')) {
              bodyPart.mako = self.listOfParts[i].mako;
            }
            if (self.listOfParts[i].hasOwnProperty('cjr')) {
              bodyPart.cjr = self.listOfParts[i].cjr;
            }
            if (self.listOfParts[i].hasOwnProperty('payorType')) {
              if (self.listOfParts[i].payorType == 2) {
                bodyPart.bpci = self.getBpci()
              }
              bodyPart.payorType = self.listOfParts[i].payorType
            }
            if (self.listOfParts[i].hasOwnProperty('hic')) {
              bodyPart.hic = self.listOfParts[i].hic;
            }
            if (self.listOfParts[i].hasOwnProperty('dischargeDate')) {
              bodyPart.dischargeDate = self.datepipe.transform(self.listOfParts[i].dischargeDate, 'yyyy-MM-dd');
            }
            if (self.listOfParts[i].hasOwnProperty('dischargeLoc')) {
              bodyPart.dischargeLoc = self.listOfParts[i].dischargeLoc;
            }
            if (self.listOfParts[i].hasOwnProperty('facilityPhone')) {
              bodyPart.facilityPhone = self.listOfParts[i].facilityPhone;
            }
            if (self.listOfParts[i].hasOwnProperty('facilityContact')) {
              bodyPart.facilityContact = self.listOfParts[i].facilityContact;
            }
            if (self.listOfParts[i].hasOwnProperty('dischargeUserName')) {
              bodyPart.dischargeWith = self.listOfParts[i].dischargeUserName;
            }
            if (self.listOfParts[i].hasOwnProperty('dischargeTo')) {
              if (self.listOfParts[i].dischargeTo != "") {
                let index = _.findIndex(self.snfList, (o: any): any => {
                  return o.dischargeHospitalMasterId == self.listOfParts[i].dischargeTo
                })
                bodyPart.dischargeTo = self.snfList[index].dischargeTo;
                bodyPart.dischargeId = self.snfList[index].dischargeId;
                bodyPart.dischargeHospitalMasterId = self.snfList[index].dischargeHospitalMasterId;
              }
            }

          }
          self.temPatien.AddBodyPart[i] = bodyPart;

        } else {
          self.temPatien.AddBodyPart[i] = self.defaultBodyPart;
        }
      }
      if (self.imagearr.length) {
        if (self.temPatien.uploadimage.length) {
          resolve(self.temPatien)
        }
      } else {
        resolve(self.temPatien)
      }

    });

    return promise;
  }
  //get user id of the discharge with option
  formdischaregeChange(event, form) {
    let self = this;
    if (event == 'Choose') {
      if (form == 'main') {
        if (self.bodyPartDetails.dischargeUserName) {
          delete self.bodyPartDetails.dischargeUserName
        }
      }
      if (form != 'main') {
        if (self.listOfParts[form].dischargeUserName) {
          delete self.listOfParts[form].dischargeUserName
        }
      }
    }
    if (event != 'Choose') {
      // if(form == 'main'){
      self.getsurgeonUserName(event, form)
      // }
      // if(form != 'main'){
      //   self.listOfParts[form].dischargeUserName = self.getsurgeonUserName(event,)
      // }
    }
  }
  //set the user name for selected surgeon
  /**
   * 
   * @param id user id of surgeon
   * @param form index
   */
  getsurgeonUserName(id, form) {
    let self = this;
    self.patientService.getSurgeonUserId(id)
      .subscribe(data => {
        if (form == 'main') {
          self.bodyPartDetails.dischargeUserName = data.surUserAccId;
        }
        if (form != 'main') {
          self.listOfParts[form].dischargeUserName = data.surUserAccId;
        }
        return;
      })
  }
  //calculate the bpci
  getBpci() {
    let self = this;
    let diff_ms = Date.now() - self.newPatient.dob.getTime();
    let age_dt = new Date(diff_ms);

    let age = Math.abs(age_dt.getUTCFullYear() - 1970);
    if (age >= 65) {
      return 'Yes';
    }
    if (age < 65) {
      return 'No'
    }
  }

  //get view worrflow episodes
  /**
   * 
   * @param template view workflow template
   * @param workflow workflowId
   */
  openViewModal(template: TemplateRef<any>, workflowId: any) {
    let self = this;
    self.patientService.getWorkflowStages(workflowId)
      .subscribe(data => {
        self.stageArray = data
        if (data.length) {
          self.getStageDetails(data[0]['episodeId'])
        }
        this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'materialtab gray modal-lg' }));
        // this.viewWorkflow= workflow
      })

  }
  //get stage Material Details array
  /**
   * 
   * @param id episode Id
   */
  getStageDetails(id) {
    let self = this;
    self.showTable = false
    self.patientService.getStagesMaterials(id)
      .subscribe(data => {
        self.materialsArray = _.orderBy(data, ['elapsedTime'], ['desc']);
        self.showTable = true
      },
        err => {
          self.showTable = true;
        }
      )
  }

  //clear body part value 
  /**
   * 
   * @param i index
   */
  clearBodyPart(i) {
    let self = this;
    self.listOfParts[i].bodyPart = ''
  }
  dateValueChange(event) {
    if (event.keyCode != 8) {
      if (event.target.value.length == 2 || event.target.value.length == 5) {
        var thisVal = event.target.value;
        thisVal += '/';
        event.target.value = thisVal;
      }
    }
  }
}
